import {
  OneOfElementListChildren,
  OneOfListElements,
} from '@shared/models/project.model';
import {
  getSbefGroupListLabel,
  getSbefScopeGroupKeyForCode,
  getSbefGroupByCode,
  normalizeSbefScopeGroupKey,
  orderSbefResolvedGroups,
} from '@shared/helpers/sbef-grouping.helpers';
import { getSbefCodeFromElementOrRecipe } from '@shared/helpers/sbef.helpers';
import { SBEFCustomGroup } from '@shared/construction/sbef-custom-group.model';
import { isElement } from '@shared/helpers/recursive-element.helpers';
import { SbefCode } from '@shared/construction/sbef.model';
import { createLocalStorageStore } from '@client/helpers/local-storage.helpers';
import { ElementGroupingOption } from '../element-grouping.model';

const useElementListGroupByStore =
  createLocalStorageStore<ElementGroupingOption>(
    'elements_view_group_by',
    'none',
  );

export const useElementListGroupBy = () => {
  return [
    useElementListGroupByStore.useStore(),
    useElementListGroupByStore.set,
  ] as const;
};

export type ElementGroupingHelpers = {
  id: string;
  getGroupKey: (element: OneOfListElements) => string;
  getGroupLabel: (key: string) => string;
  orderKeys: (keys: string[]) => string[];
  getSearchLabel: (
    item: OneOfListElements,
    path: OneOfElementListChildren[],
  ) => string | undefined;
};

export const createSbefGroupingHelpers = (
  customGroups: SBEFCustomGroup[],
): ElementGroupingHelpers => ({
  id: 'sbef',
  getGroupKey: (element) => {
    const code: SbefCode | undefined = isElement(element)
      ? getSbefCodeFromElementOrRecipe(element)
      : undefined;
    return getSbefScopeGroupKeyForCode(code, customGroups);
  },
  getGroupLabel: (key) => getSbefGroupListLabel(key, customGroups),
  orderKeys: (keys) => {
    const resolved = keys.map((k) =>
      getSbefGroupByCode(normalizeSbefScopeGroupKey(k), customGroups),
    );
    return orderSbefResolvedGroups(resolved).map((g) => g.key);
  },
  getSearchLabel: (item, path) => {
    const items = isElement(item) ? [item] : [...path].reverse();
    const nearestElement = items.find(isElement);
    if (!nearestElement) return undefined;
    const code = getSbefCodeFromElementOrRecipe(nearestElement);
    return getSbefGroupListLabel(
      getSbefScopeGroupKeyForCode(code, customGroups),
      customGroups,
    );
  },
});
